import type { TextProps } from '@react-pdf/renderer';

export type HyphenationCallback = NonNullable<TextProps['hyphenationCallback']>;

export const noHyphenation: HyphenationCallback = (word: string) => {
  return [word];
};
